<span class="message-control-label label-visible" #messageLabel>
    <span *ngIf="message.Payload.Radius">{{message.Payload.Radius}}km um </span>{{message.Payload.Vicinity}}    
</span>

<div class="map readonly" >
    <div #gmap></div>
</div>